import React, { useState, useEffect } from 'react';
import { PROGRESS_STEP } from '../../constants.js';
import ProcessingZoneComponent from './ProcessingZoneComponent.js';

var ProcessingZoneContainer = function (_a) {
    var files = _a.files, title = _a.title, _b = _a.cancelBtnLabel, cancelBtnLabel = _b === void 0 ? 'Cancel' : _b, onCancel = _a.onCancel, onProcess = _a.onProcess;
    var _c = useState({
        intervalId: 0,
        progress: PROGRESS_STEP
    }), progressConfig = _c[0], setProgressConfig = _c[1];
    var areFilesUploading = !!files.find(function (file) { return file.isUploading; });
    useEffect(function () {
        // start processing files if no file is currently uploading
        if (files.length && !areFilesUploading && onProcess) {
            onProcess();
        }
    }, [areFilesUploading, files.length, onProcess]);
    var totalFileSize = 0;
    files.forEach(function (file) { return (totalFileSize = totalFileSize + file.size); });
    return (React.createElement(ProcessingZoneComponent, { title: title, cancelBtnLabel: cancelBtnLabel, areFilesUploading: areFilesUploading, totalFileSize: totalFileSize, progressConfig: progressConfig, setProgressConfig: setProgressConfig, onCancel: onCancel }));
};

export { ProcessingZoneContainer as default };
//# sourceMappingURL=ProcessingZoneContainer.js.map
